let sidebarItems = document.querySelectorAll('.main-list-item')
if (sidebarItems) {
    sidebarItems.forEach((item) => {
        item.addEventListener("click", (e) => {
            if (!item.querySelector(".dropdown").contains(e.target))
                item.classList.toggle('main-list-item-active')
        })
    })
}
